import React from 'react'
import style from './style.module.less'

export default props => {
  const {
    store: { service, addModal }
  } = props
  return (
    <div className={style.modal}>
      <p className={style.label}>待选择模块：</p>
      {service.map(
        (el, i) =>
          !el.isShow && (
            <div
              key={i}
              className={style.modalItem}
              onClick={() => addModal(i)}
            >
              {el.text}
            </div>
          )
      )}
    </div>
  )
}
